import { render, staticRenderFns } from "./DuplicateStatusChangeSelect.vue?vue&type=template&id=14a8823c&"
import script from "./DuplicateStatusChangeSelect.vue?vue&type=script&lang=ts&"
export * from "./DuplicateStatusChangeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateStatusChangeSelect.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
